"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackageDetailsForm = void 0;
var classnames_1 = __importDefault(require("classnames"));
var formik_1 = require("formik");
var react_1 = __importStar(require("react"));
var throttle_debounce_1 = require("throttle-debounce");
var Yup = __importStar(require("yup"));
require("./PackageDetailsForm.scss");
var Toggle_1 = require("@app/components/controls/Toggle");
var UserLookupField_1 = require("@app/features/transfers/components/upload/UserLookupField");
var constants_1 = require("@app/shared/constants");
var matomo_1 = require("@app/shared/matomo");
var utils_1 = require("@app/shared/utils");
var initialState = {
    notifiableUsersDownload: [],
    notifiableUsersUpload: [],
    selectedUsers: [],
    advancedOptionsVisible: false,
    isWorkgroupPackage: false
};
var validationSchema = Yup.object().shape({
    to: Yup.array().of(Yup.string()).min(1, 'Please enter one or more recipients').test('maxCharacters', 'Too many recipients. Please remove one or more.', function (value) {
        return (value) ? value.join(',').length < constants_1.RECIPIENTS_LIST_CHARACTER_LIMIT : false;
    }),
    subject: Yup.string().required('Please enter a subject').max(75, 'Subject is too long').test('subjectNotBlank', 'Please enter a subject', function (value) {
        if (value) {
            return utils_1.trimSpacesAndPeriods(value) !== '';
        }
        return false;
    }).test('noEmojis', 'No emojis please, this is serious business.', function (value) {
        return !utils_1.containsEmoji(value);
    }),
    message: Yup.string().test('noEmojis', 'No emojis please, this is serious business.', function (value) {
        return !utils_1.containsEmoji(value);
    }),
    packageId: Yup.string(),
    packageExpirationDays: Yup.number(),
    userLookupValue: Yup.string(),
    recipientUserLookupValue: Yup.string().email('Please enter a valid email address'),
    notifyOnDownload: Yup.boolean(),
    notifiableOnDownload: Yup.array().of(Yup.string()).when('notifyOnDownload', {
        is: true,
        then: Yup.array().of(Yup.string()).min(1),
        otherwise: Yup.array().of(Yup.string()).min(0)
    }),
    notifiableDownloadUserLookupValue: Yup.string().email('Please enter a valid email address'),
    notifyOnUpload: Yup.boolean(),
    notifiableOnUpload: Yup.array().of(Yup.string()).when('notifyOnUpload', {
        is: true,
        then: Yup.array().of(Yup.string()).min(1),
        otherwise: Yup.array().of(Yup.string()).min(0)
    }),
    notifiableUploadUserLookupValue: Yup.string().email('Please enter a valid email address'),
    encryptPackage: Yup.boolean(),
    enableForwarding: Yup.boolean(),
    isWorkgroupPackage: Yup.boolean()
});
var PackageDetailsForm = /** @class */ (function (_super) {
    __extends(PackageDetailsForm, _super);
    function PackageDetailsForm(props) {
        var _this = _super.call(this, props) || this;
        _this.state = initialState;
        _this.handleQuery = function () {
            _this.props.onQueryUsers(_this.props.values.userLookupValue);
        };
        _this.renderNewUserInvitationMessage = function () {
            var newUsers = _this.state.selectedUsers.filter(function (u) { return !u.doesExist; }).map(function (u) { return u.email; });
            if (newUsers.length > 0) {
                return (react_1.default.createElement("div", { className: "message is-small is-info" },
                    react_1.default.createElement("div", { className: "message-body" },
                        newUsers.join(', '),
                        " ",
                        'will be invited to the system once package is submitted.')));
            }
        };
        _this.handleCancel = function () {
            // TODO: Wording seems inaccurate
            var confirmResult = confirm('Are you sure? Canceling clears all fields and removes all uploaded packages');
            if (confirmResult) {
                _this.setState(__assign(__assign({}, _this.state), { isWorkgroupPackage: false, notifiableUsersDownload: [], notifiableUsersUpload: [], selectedUsers: [] }));
                _this.props.resetForm();
                _this.props.onCancel(true);
            }
        };
        _this.handleEncryptPackageChange = function () {
            new matomo_1.MatomoTracker().trackEvent('Upload Form', 'Toggle Encrypt Package', !_this.props.values.encryptPackage ? 'On' : 'Off');
            _this.props.setFieldValue('encryptPackage', !_this.props.values.encryptPackage);
        };
        _this.handleEnableForwardingChange = function () {
            new matomo_1.MatomoTracker().trackEvent('Upload Form', 'Toggle Enable Forwarding', !_this.props.values.enableForwarding ? 'On' : 'Off');
            _this.props.setFieldValue('enableForwarding', !_this.props.values.enableForwarding);
        };
        _this.handleNotifyOnDownloadChange = function () {
            new matomo_1.MatomoTracker().trackEvent('Upload Form', 'Toggle Notify on Download', !_this.props.values.notifyOnDownload ? 'On' : 'Off');
            _this.props.setFieldValue('notifyOnDownload', !_this.props.values.notifyOnDownload);
        };
        _this.handleNotifyOnUploadChange = function () {
            new matomo_1.MatomoTracker().trackEvent('Upload Form', 'Toggle Notify on Upload', !_this.props.values.notifyOnUpload ? 'On' : 'Off');
            _this.props.setFieldValue('notifyOnUpload', !_this.props.values.notifyOnUpload);
        };
        _this.toggleAdvancedOptions = function () {
            new matomo_1.MatomoTracker().trackEvent('Upload Form', 'Toggle Advanced Options', !_this.state.advancedOptionsVisible ? 'On' : 'Off');
            _this.setState(__assign(__assign({}, _this.state), { advancedOptionsVisible: !_this.state.advancedOptionsVisible }));
        };
        _this.setFormikFieldValue = function (field, value, shouldValidate) {
            _this.props.setFieldValue(field, value, shouldValidate);
        };
        _this.setFormikFieldTouched = function (field, isTouched, shouldValidate) {
            _this.props.setFieldTouched(field, isTouched, shouldValidate);
        };
        _this.setNewState = function (field, selectedUsers) {
            if (field === 'to') {
                var isWorkgroupPackage_1 = false;
                selectedUsers.map(function (user) {
                    if (user.isWorkgroup) {
                        isWorkgroupPackage_1 = true;
                    }
                });
                _this.setState(__assign(__assign({}, _this.state), { isWorkgroupPackage: isWorkgroupPackage_1, selectedUsers: selectedUsers }));
                _this.setFormikFieldValue('isWorkgroupPackage', isWorkgroupPackage_1);
            }
            else if (field === 'notifiableOnDownload') {
                _this.setState(__assign(__assign({}, _this.state), { notifiableUsersDownload: selectedUsers }));
            }
            else if (field === 'notifiableOnUpload') {
                _this.setState(__assign(__assign({}, _this.state), { notifiableUsersUpload: selectedUsers }));
            }
        };
        _this.updatePackageExpiration = function (e) {
            new matomo_1.MatomoTracker().trackEvent('Upload Form', 'Update Package Expiration', e.target.value);
            _this.props.setFieldValue('packageExpirationDays', e.target.value);
        };
        _this.debouncedQuery = throttle_debounce_1.debounce(500, _this.handleQuery);
        return _this;
    }
    PackageDetailsForm.prototype.componentWillUnmount = function () {
        this.setState({
            advancedOptionsVisible: false,
            isWorkgroupPackage: false,
            notifiableUsersDownload: [],
            notifiableUsersUpload: [],
            selectedUsers: []
        });
        this.props.resetForm();
        this.props.onCancel(false);
    };
    PackageDetailsForm.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        if (this.props.shouldReset !== prevProps.shouldReset && this.props.shouldReset) {
            this.props.resetForm();
            if (this.props.packageDetails && this.props.packageDetails.id) {
                this.props.onCancel(true);
            }
            this.setState({
                advancedOptionsVisible: false,
                isWorkgroupPackage: false,
                notifiableUsersDownload: [],
                notifiableUsersUpload: [],
                selectedUsers: []
            });
        }
        if (prevProps.packageDetails && this.props.packageDetails === undefined) {
            this.props.resetForm();
            this.setState(__assign(__assign({}, this.state), { isWorkgroupPackage: false, notifiableUsersDownload: [], notifiableUsersUpload: [], selectedUsers: [] }));
        }
        if (prevProps.values && (prevProps.values.subject === '' && prevProps.values.subject !== this.props.values.subject)) {
            setTimeout(function () {
                void _this.props.validateForm();
            }, 500);
        }
        if ((this.props.selectedRemoteSource !== prevProps.selectedRemoteSource && this.props.selectedRemoteSource > -1) ||
            (this.props.pluginEnabled !== prevProps.pluginEnabled && !this.props.pluginEnabled) ||
            (!this.props.pluginEnabled && this.props.httpGatewayStatus !== prevProps.httpGatewayStatus)) {
            this.props.setFieldValue('encryptPackage', false);
        }
    };
    PackageDetailsForm.prototype.render = function () {
        var _a = this.props, values = _a.values, touched = _a.touched, errors = _a.errors;
        if (values.subject.startsWith(constants_1.FORWARD_MESSAGE_SUBJECT_PREFIX)) {
            touched.subject = true;
        }
        // Encrypt option should only display if it is a plugin transfer AND it is a new package (not forward)
        var encryptOptionAvailable = this.props.pluginEnabled && !this.props.packageDetails && this.props.selectedRemoteSource < 0;
        var expirationValues = Array.from({ length: this.props.packageExpirationDays }, function (_, i) { return i + 1; });
        var renderExpirationOption = function (n) {
            return react_1.default.createElement("option", { key: n, value: n }, n);
        };
        return (react_1.default.createElement(formik_1.Form, { className: "package-details-form" },
            this.renderNewUserInvitationMessage(),
            react_1.default.createElement("div", { className: "field" },
                react_1.default.createElement("label", { className: "label" }, "To"),
                react_1.default.createElement("div", { className: "control" },
                    react_1.default.createElement(UserLookupField_1.UserLookupField, { defaultValue: '', fieldEnabled: values.to.join(',').length < constants_1.RECIPIENTS_LIST_CHARACTER_LIMIT, fieldLookupValueName: 'recipientUserLookupValue', fieldName: 'to', formLookupValueName: 'userLookupValue', inputValue: values.recipientUserLookupValue, isWorkgroupPackage: this.state.isWorkgroupPackage, selectedUsers: this.state.selectedUsers, selectedValues: this.props.values.to, typeaheadUsers: this.props.users, debouncedQuery: this.debouncedQuery, handleQuery: this.handleQuery, onValidateUser: this.props.onValidateUser, setFieldValue: this.setFormikFieldValue, setFieldTouched: this.setFormikFieldTouched, setSelectedUsers: this.setNewState }),
                    touched.to && errors.to &&
                        react_1.default.createElement("p", { className: "help is-danger" }, errors.to),
                    touched.recipientUserLookupValue && errors.recipientUserLookupValue &&
                        react_1.default.createElement("p", { className: "help is-danger" }, "Please enter a valid email address"))),
            react_1.default.createElement("div", { className: "field" },
                react_1.default.createElement("label", { className: "label" }, "Subject"),
                react_1.default.createElement("div", { className: "control" },
                    react_1.default.createElement(formik_1.Field, { type: "text", name: "subject", className: "input" }),
                    touched.subject && errors.subject &&
                        react_1.default.createElement("p", { className: "help is-danger" }, errors.subject))),
            react_1.default.createElement("div", { className: "field" },
                react_1.default.createElement("label", { className: "label icon-adjacent" },
                    "Message ",
                    react_1.default.createElement("span", { className: "help is-inline" }, "(optional, visible in email)")),
                react_1.default.createElement("span", { className: "icon message-help-tooltip tooltip is-tooltip-top", "data-tooltip": "Recipients will receive an email notification once the package is ready for download. Your message will be visible in that email." },
                    react_1.default.createElement("i", { className: "fas fa-info-circle" })),
                react_1.default.createElement("div", { className: "control" },
                    react_1.default.createElement(formik_1.Field, { component: "textarea", name: "message", className: "input message-textarea", rows: "3" }),
                    errors.message &&
                        react_1.default.createElement("p", { className: "help is-danger" }, errors.message))),
            this.state.advancedOptionsVisible &&
                react_1.default.createElement("div", { className: "advanced-options" },
                    !this.props.packageDetails && values.packageId === '' &&
                        react_1.default.createElement("div", { className: "columns is-desktop is-mobile" },
                            react_1.default.createElement("div", { className: "column expiration-title" },
                                react_1.default.createElement("label", { className: "label" },
                                    "Expire Package after",
                                    react_1.default.createElement(formik_1.Field, { component: "select", name: "packageExpirationDays", className: "expiration-select", onChange: this.updatePackageExpiration }, expirationValues.map(function (ev) { return renderExpirationOption(ev); })),
                                    "Days"))),
                    react_1.default.createElement("div", { className: "columns is-desktop is-mobile" },
                        react_1.default.createElement("div", { className: "column download-notification-title" },
                            react_1.default.createElement("div", { className: "field download-notification-lookup-field" },
                                react_1.default.createElement(formik_1.Field, { type: "hidden", name: "notifyOnDownload" }),
                                react_1.default.createElement("label", { className: "label" }, "Notify On Download"))),
                        react_1.default.createElement("div", { className: "column download-notification-toggle" },
                            react_1.default.createElement(Toggle_1.Toggle, { checked: values.notifyOnDownload, id: 'notifyOnDownloadToggle', onToggle: this.handleNotifyOnDownloadChange }))),
                    values.notifyOnDownload &&
                        react_1.default.createElement("div", { className: "field download-notification-lookup-field" },
                            react_1.default.createElement(UserLookupField_1.UserLookupField, { defaultValue: this.props.loggedInUserEmail, fieldEnabled: values.notifyOnDownload, fieldLookupValueName: 'notifiableDownloadUserLookupValue', fieldName: 'notifiableOnDownload', formLookupValueName: 'userLookupValue', inputValue: values.notifiableDownloadUserLookupValue, selectedUsers: this.state.notifiableUsersDownload, selectedValues: this.props.values.notifiableOnDownload, typeaheadUsers: this.props.users, debouncedQuery: this.debouncedQuery, handleQuery: this.handleQuery, onValidateUser: this.props.onValidateUser, setFieldValue: this.setFormikFieldValue, setFieldTouched: this.setFormikFieldTouched, setSelectedUsers: this.setNewState })),
                    react_1.default.createElement("div", { className: "columns is-desktop is-mobile" },
                        react_1.default.createElement("div", { className: "column upload-notification-checkbox" },
                            react_1.default.createElement("div", { className: "field upload-notification-lookup-field" },
                                react_1.default.createElement(formik_1.Field, { type: "hidden", name: "notifyOnUpload" }),
                                react_1.default.createElement("label", { className: "label" }, "Notify On Upload"))),
                        react_1.default.createElement("div", { className: "column upload-notification-toggle" },
                            react_1.default.createElement(Toggle_1.Toggle, { checked: values.notifyOnUpload, id: 'notifyOnUploadToggle', onToggle: this.handleNotifyOnUploadChange }))),
                    values.notifyOnUpload &&
                        react_1.default.createElement("div", { className: "field upload-notification-lookup-field" },
                            react_1.default.createElement(UserLookupField_1.UserLookupField, { defaultValue: '', fieldEnabled: values.notifyOnUpload, fieldLookupValueName: 'notifiableUploadUserLookupValue', fieldName: 'notifiableOnUpload', formLookupValueName: 'userLookupValue', inputValue: values.notifiableUploadUserLookupValue, selectedUsers: this.state.notifiableUsersUpload, selectedValues: this.props.values.notifiableOnUpload, typeaheadUsers: this.props.users, debouncedQuery: this.debouncedQuery, handleQuery: this.handleQuery, onValidateUser: this.props.onValidateUser, setFieldValue: this.setFormikFieldValue, setFieldTouched: this.setFormikFieldTouched, setSelectedUsers: this.setNewState })),
                    encryptOptionAvailable &&
                        react_1.default.createElement("div", { className: "field encrypt-package-field" },
                            react_1.default.createElement(formik_1.Field, { type: "hidden", name: "encryptPackage" }),
                            react_1.default.createElement("label", { className: "label" }, "Encrypt Package with Password"),
                            react_1.default.createElement("span", { className: "icon encryption-help-tooltip tooltip", "data-tooltip": "You will be prompted for a password after you click Send Package. Any recipients of the package will need to know this password in order to view the files." },
                                react_1.default.createElement("i", { className: "fas fa-info-circle" })),
                            react_1.default.createElement(Toggle_1.Toggle, { checked: values.encryptPackage, id: 'encryptPackageToggle', onToggle: this.handleEncryptPackageChange })),
                    this.props.loggedInUserIsInternal &&
                        react_1.default.createElement("div", { className: "field enable-forwarding-field" },
                            react_1.default.createElement(formik_1.Field, { type: "hidden", name: "enableForwarding" }),
                            react_1.default.createElement("label", { className: "label" }, "Allow Package Forwarding"),
                            react_1.default.createElement("span", { className: "icon enable-forwarding-help-tooltip tooltip", "data-tooltip": "Recipients have the ability to forward this package." },
                                react_1.default.createElement("i", { className: "fas fa-info-circle" })),
                            react_1.default.createElement(Toggle_1.Toggle, { checked: values.enableForwarding, id: 'enableForwardingToggle', onToggle: this.handleEnableForwardingChange }))),
            react_1.default.createElement("div", { className: "level is-mobile control-buttons" },
                react_1.default.createElement("div", { className: "level-left" },
                    react_1.default.createElement("div", { className: "level-item" },
                        react_1.default.createElement("div", { className: "field" },
                            react_1.default.createElement("div", { className: "control" },
                                react_1.default.createElement("div", { className: "buttons" },
                                    react_1.default.createElement("button", { type: "button", className: "button is-light", onClick: this.handleCancel }, "Cancel"),
                                    react_1.default.createElement("button", { type: "submit", className: "button button-yellow", disabled: this.props.disabled || Object.keys(this.props.errors).length > 0 }, "Send Package")))))),
                react_1.default.createElement("div", { className: "level-right" },
                    react_1.default.createElement("div", { className: "level-item" },
                        react_1.default.createElement("a", { className: "is-tooltip-left has-text-white", onClick: this.toggleAdvancedOptions, "data-tooltip": "Toggle advanced options" },
                            react_1.default.createElement("label", { className: "label icon-adjacent has-cursor-pointer" }, "Advanced Options"),
                            react_1.default.createElement("span", { className: "icon" },
                                react_1.default.createElement("i", { className: classnames_1.default('fas', {
                                        'fa-minus-square': this.state.advancedOptionsVisible,
                                        'fa-plus-square': !this.state.advancedOptionsVisible
                                    }) })))))),
            react_1.default.createElement(formik_1.Field, { type: "hidden", name: "packageId" }),
            react_1.default.createElement(formik_1.Field, { type: "hidden", name: "isWorkgroupPackage" })));
    };
    return PackageDetailsForm;
}(react_1.Component));
exports.PackageDetailsForm = PackageDetailsForm;
exports.default = formik_1.withFormik({
    validationSchema: validationSchema,
    enableReinitialize: true,
    mapPropsToValues: function (props) {
        return {
            to: [],
            subject: (props.packageDetails) ? constants_1.FORWARD_MESSAGE_SUBJECT_PREFIX + " " + props.packageDetails.title : '',
            message: (props.packageDetails && props.packageDetails.note) ? "\n\n--------- Forwarded note ---------\n" + props.packageDetails.note : '',
            packageId: (props.packageDetails) ? props.packageDetails.id : '',
            packageExpirationDays: props.packageExpirationDays,
            isWorkgroupPackage: false,
            userLookupValue: '',
            recipientUserLookupValue: '',
            notifyOnDownload: true,
            notifiableOnDownload: [props.loggedInUserEmail],
            notifiableDownloadUserLookupValue: '',
            notifyOnUpload: false,
            notifiableOnUpload: (props.packageDetails) ? [] : [],
            notifiableUploadUserLookupValue: '',
            encryptPackage: (props.packageDetails) ? !!props.packageDetails.encrypted : false,
            enableForwarding: (props.packageDetails) ? !props.packageDetails.disableForwarding : true
        };
    },
    handleSubmit: function (values, bag) {
        bag.props.onSubmit(values.to, values.subject, values.message, values.packageId, values.packageExpirationDays, values.notifyOnDownload, values.notifiableOnDownload, values.notifyOnUpload, values.notifiableOnUpload, values.encryptPackage, values.enableForwarding, values.isWorkgroupPackage);
    }
})(PackageDetailsForm);
